// src/layouts/AppLayout.js
import { Navigate, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useAuth } from '../contexts/AuthContext';
import BuildBadge from '../components/BuildBadge';
import SettingsNav from '../components/SettingsNav';
import OnboardingChecklist from '../components/OnboardingChecklist';

function AppLayout({ children }) {
  const { subscriberId, userRole } = useAuth();
  const location = useLocation();
  // Settings pages carry the section rail (design handoff option 7d). It lives
  // here rather than in each page so all ~18 of them get it from one place —
  // and so a page can't quietly ship without a way back to its siblings.
  const isSettings = location.pathname.startsWith('/settings');

  // Subscriber-scoped routes require a subscriber to be selected
  if (!subscriberId && userRole !== 'customer') {
    return <Navigate to="/select-subscriber" replace />;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 'calc(100vh - 64px)' }}>
      <Container component="main" maxWidth="xl" sx={{ flexGrow: 1, py: 3 }}>
        {isSettings ? (
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: { xs: 0, md: 3 } }}>
            <SettingsNav />
            <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
          </Box>
        ) : (
          children
        )}
      </Container>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 2, py: 1 }}>
        <BuildBadge />
      </Box>
      {/* Floats over every workspace page; renders nothing once set up. */}
      <OnboardingChecklist />
    </Box>
  );
}

export default AppLayout;